import * as React from 'react';
import { Grid } from 'ui';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      marginLeft: -4,
      marginRight: -4,
      maxWidth: '100%',
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        overflow: 'visible',
        justifyContent: 'normal',
        marginLeft: theme.spacing(1.5),
        marginRight: theme.spacing(1.5),
      },
    },
    gridList: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
      scrollPadding: `${theme.spacing(3)}px`, // something in material-ui wasn't adding px to this
      // scrollSnapType: 'x proximity', disabled for chase
      transform: 'translateZ(0)',
      [theme.breakpoints.up('sm')]: {
        flexWrap: 'wrap',
        overflowY: 'visible',
      },
      '& .MuiGrid-item:first-child': {
        paddingLeft: theme.spacing(3),
      },
      '& .MuiGrid-item:last-child': {
        paddingRight: theme.spacing(3),
      },
    },
    // 2020-04-01 Kelly M. - no joke, we need to make this into a wrapper similar to typography but for grid
    // if this becomes a more formal pattern, like 2 spacing on mobile but 3 on tablet
    // this mimics changing the spacing property to 3 on `sm` breakpoint
    cardSpacing: {
      [theme.breakpoints.up('sm')]: {
        '&.MuiGrid-spacing-xs-2': {
          margin: theme.spacing(-1.5),
          width: `calc(100% + 24px)`,
        },
        '&.MuiGrid-spacing-xs-2 > .MuiGrid-item': {
          padding: theme.spacing(1.5),
        },
      },
    },
  })
);

export const ScrollableList: React.FunctionComponent<{}> = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.listContainer}>
      <Grid
        component="ul"
        className={`${classes.gridList} ${classes.cardSpacing}`}
        container
        spacing={2}
      >
        {children}
      </Grid>
    </div>
  );
};
